import {SelectionModel} from '@angular/cdk/collections';
import {Platform} from '@angular/cdk/platform';
import {Component, EventEmitter, Inject, Input, OnInit, Output,} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef,} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {ActivatedRoute, Router} from '@angular/router';
import {InfoOs} from 'src/app/domain';
import {CertifAchetService} from 'src/app/modules/services/acheteur/certif/certif-achet.service';
import {CertifFournisseurService} from 'src/app/modules/services/fournisseur/certif-four/certif-fournisseur.service';
import {ConfirmDialogService} from 'src/app/modules/services/ui/confirm-dialog.service';
import {LoginService} from 'src/app/modules/services/user/login/login.service';
import {ToastService} from 'src/app/modules/toast/toast.service';
import {Pagination} from '../../../../domain/search/Pagination';

type Column = keyof any | 'action';

@Component({
    selector: 'app-list-users-login',
    templateUrl: './list-users-login.component.html',
    styleUrls: ['./list-users-login.component.css'],
})
export class ListUsersLoginComponent implements OnInit {

    disabled_conn: boolean = true;
    @Output() next = new EventEmitter<any>();
    data: any[];
    @Input() id;
    form: FormGroup = new FormGroup({});
    acheteur;
    paginationObject: Pagination = new Pagination(0, 5);
    bizRegNo;
    encData;
    disabled = false;
    @Input() certificatees: any[];
    dataSource = new MatTableDataSource<any>();
    displayedColumns: Column[] = ['role', 'supplierNm', 'masterCd'];
    labels: Partial<Record<Column, string>> = {
        role: 'Rôle',
        supplierNm: 'Nom de société / Acheteur',
        masterCd: 'identifiant unique'
    };
    selection = new SelectionModel<any>(false, []);
    @Input() ondelete: boolean;
    certificatdetails: any[] = [];
    certificates: any[];
    infooscert: InfoOs;
    name: any;
    securevalue: string = '';
    encdatavalue: string = '';
    certiflocalbool: boolean = false;
    isAuthenticating = false;

    constructor(
        private formBuilder: FormBuilder,
        private loginService: LoginService,
        public platform: Platform,
        private dialog: MatDialog,
        private router: Router,
        private confirmdialog: ConfirmDialogService,
        private activatedRoute: ActivatedRoute,
        private certifAchetService: CertifAchetService,
        private certifFournisseurService: CertifFournisseurService,
        private toast: ToastService,
        @Inject(MAT_DIALOG_DATA) data,
        private dialogg: MatDialogRef<ListUsersLoginComponent, { data: any }>
    ) {
        this.encData = data.encData;
        this.certificates = data.data;
        this.onPaginate();

    }

    get currentDate() {
        return new Date();
    }

    get readColumns() {
        return this.displayedColumns;
    }

    ngOnInit(): void {
    }

    onSuccess() {
        this.selection.selected.forEach((row) => {
            this.name = row;
        });
        this.isAuthenticating = true;


        if (this.selection.isSelected) {
            this.dialogg.close({
                data: this.name,
            });
        }
    }

    getdetail() {

    }

    ngAfterViewInit(): void {
    }

    toggle() {
        this.disabled_conn = false;
    }


    onPaginate(pagination: Pagination = this.paginationObject) {
        const start = pagination.offSet * pagination.limit;
        const end = start + pagination.limit;
        this.dataSource.data = [...this.certificates.slice(start, end)];
    }
}
